module.exports = "mutation UpdateIssuePriority($data:IssuePriorityInput!){updateIssuePriority(data:$data){success}}"